<template>
  <div class="home">

    <div class="head row">
      <div class="tracker col-xs-6 col-md-4" v-bind:style="{
        backgroundImage: 'url(' + trackers[0] + ')'
      }"></div>
      <div class="tracker col-xs-6 col-md-4" style="margin-top: -100px;" v-bind:style="{
        backgroundImage: 'url(' + trackers[1] + ')'
      }"></div>
      <div class="tracker col-xs-6 col-md-4" v-bind:style="{
        backgroundImage: 'url(' + trackers[2] + ')'
      }"></div>
      <div class="tracker col-xs-6 col-md-3" style="margin-bottom: -100px;" v-bind:style="{
        backgroundImage: 'url(' + trackers[3] + ')'
      }"></div>
      <div class="tracker col-xs-6 col-md-3" v-bind:style="{
        backgroundImage: 'url(' + trackers[4] + ')'
      }"></div>
      <div class="tracker col-xs-6 col-md-3" v-bind:style="{
        backgroundImage: 'url(' + trackers[5] + ')'
      }"></div>
      <div class="tracker col-xs-6 col-md-3" style="margin-top: -15px;" v-bind:style="{
        backgroundImage: 'url(' + trackers[6] + ')'
      }"></div>
      <div class="welcome">
        <img class="logo" src="../assets/logo_transparent_blue_small.png" height="64" />
        <div class="logotype">Aidminder</div>
        <h1>Your medication your style</h1>
      </div>
    </div>

    <div class="sections row center-xs">

      <div class="call col-md-8">
        We are looking for beta testers! Read more below.
      </div>

      <section class="content col-md-8 row center-xs">
        <div class="col-md-6">
          <model-stl :src="objects[selectedMedication].objectASrc" ref="modelViewer" @on-load="modelLoaded" :height="400" :width="400"></model-stl>
        </div>
        <div class="col-md-6">
          <h3>A medication tracker customized for your needs</h3>
          <p>
            Aidminder is a universal medication tracker hardware, made for unique shaped dosage-delivery devices.
            Besides the notifications, our product also counts the used dosages and helps the patient to use their device correctly. Our goal is to build trackers for those unique medications, which are not supported by the current solutions, but they are still mandatory for a large group of patients.
            Right now we are targeting a selected range of inhalers, which are vital in the treatment of chronic pulmonary diseases.
            The project is developed by students from ELTE and BME Universities in Budapest in cooperation with local doctors.
          </p>
          <br>
          <b>Select medication</b>
          <multiselect v-model="selectedMedication" :options="medicationOptions" :allow-empty="false"></multiselect>
          <br>
          <b>Customize color</b>
          <div class="colors">
            <div class="color" v-for="(color, index) in colors" :key="index" v-bind:style="{backgroundColor: color}" v-on:click="selectColor(color)"></div>
          </div>
          <br><br>
        </div>
      </section>


    <!--
    <section class="editor col-md-8 row center-xs">
      <div class="col-md-6">
        <model-stl :src="objects[selectedMedication].objectASrc" ref="modelViewer" @on-load="modelLoaded" :height="400" :width="400"></model-stl>
      </div>
      <div class="col-md-6">
        <h3>Design your own Aidminder tracker</h3>
        <b>Medication</b>
        <multiselect v-model="selectedMedication" :options="medicationOptions" :allow-empty="false"></multiselect>
        <br>
        <b>Color</b>
        <div class="colors">
          <div class="color" v-for="(color, index) in colors" :key="index" v-bind:style="{backgroundColor: color}" v-on:click="selectColor(color)"></div>
        </div>
        <br>
        <b>Material</b>
        <div class="colors">
          <div class="color" v-for="(color, index) in colors" :key="index" v-bind:style="{backgroundColor: color}" ></div>
        </div> 
        <hr/>
        <span class="offer">Early-bird offer: €30</span><br>
        Tracker unit - €30<br>
        Case - €15<br>
        Offer expires: 07.15. - Normal price: €45
        <button class="btn orange" type="button"><span>Pre-order now</span></button>
      </div>
    </section>
  -->

  <section class="features col-md-8 row middle-xs">
    <div class="col-md-12">
      <h3>Main features</h3>
    </div>

    <div class="feature col-md-4">
      <font-awesome-icon :icon="'futbol'" size="2x"/>
      <h4>Easy to use</h4>
      <p><b>Just attach the tracker on your medication and we'll do the rest.</b> With a supplementary mobile application, the tracking is done automatically in the background, and only notifies you if you forget to take the dose.</p> 
    </div>
    <div class="feature col-md-4">
      <font-awesome-icon :icon="'bell'" size="2x"/>
      <h4>Contextual reminders</h4>
      <p><b>Our system can learn which time is the best for an effective reminder.</b> Aidminder only send you reminders when you actually near to your medication and we don't bother you with notifications, if you already took your daily dose.</p>
    </div>
    <div class="feature col-md-4">
      <font-awesome-icon :icon="'clipboard'" size="2x"/>
      <h4>Made for research</h4>
      <p><b>Aidminder is excellent for adherence examination and quality assurance.</b> Our hardware can be extended with specialized sensors for medication usage realted data collection. Contact us for more information.</p>
    </div>
  </section>

  <section class="onboard col-md-8">
    <h3>Interested?<br>Sign up to try out Aidminder for free!</h3>
    <p>
      We are looking for beta testers for our service. If you use a medication on a daily basis, we can provide you a free Aidminder device to help you track it's usage. In the meantime you'll also help us to develop a better experience.
    </p>

    <!-- Begin MailChimp Signup Form -->
    <link href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css" rel="stylesheet" type="text/css">
    <div id="mc_embed_signup">
      <form action="https://pulmoment.us14.list-manage.com/subscribe/post?u=ea6be6748ed99c17419569790&amp;id=9d5f2dc072" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <div id="mc_embed_signup_scroll">

          <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
          <div class="mc-field-group">
            <label for="mce-EMAIL">Email Address  <span class="asterisk">*</span>
            </label>
            <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL">
          </div>
          <div class="mc-field-group">
            <label for="mce-FMEDICATIO">Your daily medication(s)  <span class="asterisk">*</span>
            </label>
            <input type="text" value="" name="FMEDICATIO" class="required" id="mce-FMEDICATIO">
          </div>
          <div id="mce-responses" class="clear">
            <div class="response" id="mce-error-response" style="display:none"></div>
            <div class="response" id="mce-success-response" style="display:none"></div>
          </div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
          <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_ea6be6748ed99c17419569790_9d5f2dc072" tabindex="-1" value=""></div>
          <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button"></div>
        </div>
      </form>
    </div>
    <!--End mc_embed_signup-->
    <p>
      Got any questions? Contact us at: <a href="mailto:hello@aidminder.com">hello@aidminder.com</a>
    </p>
  </section>

  <div class="footer col-md-8 center-xs">
    <img class="logo-footer" src="../assets/logo_transparent_small.png" height="32" style="opacity: 0.3; margin: 16px;" />
  </div>

</div>

</div>
</template>

<script>
  import FontAwesomeIcon from "@fortawesome/vue-fontawesome";
  import fontawesome from "@fortawesome/fontawesome";
  import brands from "@fortawesome/fontawesome-free-brands";
  import regular from "@fortawesome/fontawesome-free-solid";
  import { ModelObj, ModelStl } from "vue-3d-model";
  import Multiselect from "vue-multiselect";
  import { Box3 } from 'three';

  fontawesome.library.add(brands);
  fontawesome.library.add(regular);

  var scrollOffset = -500;

  export default {
    name: "HelloWorld",
    components: {
      FontAwesomeIcon,
      ModelObj,
      ModelStl,
      Multiselect
    },
    data() {
      return {
        email: "",
        medication: "",
        selectedMedication: "Ellipta",
        medicationOptions: ["EasyHaler", "Turbohaler", "Ellipta"],
        trackers: [
        require("../assets/trackers/turbohaler_red.jpg"),
        require("../assets/trackers/diskus_trans_blur.jpg"),
        require("../assets/trackers/easyhaler_sand.jpg"),
        require("../assets/trackers/ellipta_blue.jpg"),
        require("../assets/trackers/easyhaler_sand_blur.jpg"),
        require("../assets/trackers/diskus_trans.jpg"),
        require("../assets/trackers/pill_orange.jpg")
        ],
        objects: {
          "EasyHaler": {
            objectASrc: "/static/models/tarto_Vivi.stl",
            objectBSrc: "/static/models/gyogyszer_Vivi.stl",
            objectA: null,
            objectB: null
          },
          "Turbohaler": {
            objectASrc: "/static/models/turbohaler_tok.stl",
            objectBSrc: "/static/models/turbohaler_gyogyszer.stl",
            objectA: null,
            objectB: null
          },
          "Ellipta": {
            objectASrc: "/static/models/WEB_ellipta_tok.stl",
            objectBSrc: "/static/models/WEB_ellipta_gyogyszer.stl",
            objectA: null,
            objectB: null
          }
        },
        colors: [
        "#EA2027",
        "#EE5A24",
        "#FFC312",
        "#009432",
        "#0652DD",
        "#9980FA",
        "#833471",
        "#CBCBCB",
        "#000000"
        ]
      };
    },
    watch: {
      selectedMedication: function(val, oldVal) {
        if(val != oldVal){
          for (var i = this.$refs.modelViewer._data.wrapper.children.length - 1; i >= 0; i--) {
            this.$refs.modelViewer._data.wrapper.remove(this.$refs.modelViewer._data.wrapper.children[i]);
          }
          this.objects[oldVal].objectA = null;
          this.objects[oldVal].objectB = null;
          console.log(this.objects[oldVal]);
        }
      }
    },
    methods: {
      handleScroll () {
        scrollOffset = Math.min(-(500-window.scrollY), 0);
        var trackers = document.getElementsByClassName("tracker");
        for (var index = 0; index < trackers.length; index++) {
          if(index == 1 || index == 4){
            trackers[index].style.transform = "translateY(" + (-50 + (-1*scrollOffset*0.1)) + "px)";
          } else if(index == 5 || index == 6){
            trackers[index].style.transform = "translateY(" + (-350 + (-1*scrollOffset*0.9)) + "px)";
          } else {
            trackers[index].style.transform = "translateY(" + (-200 + (-1*scrollOffset*0.4)) + "px)";
          }
        }
      },
      modelLoaded: function() {
        var selectedObject = this.objects[this.selectedMedication];
        if(!selectedObject.objectA){
          selectedObject.objectA = this.$refs.modelViewer._data.object;
          selectedObject.objectA.scale.set(0.5, 0.5, 0.5);
          this.$refs.modelViewer._data.object = null;
          this.$refs.modelViewer._props.src = selectedObject.objectBSrc;
          this.$refs.modelViewer.load();
        } else {
          selectedObject.objectB = this.$refs.modelViewer._data.object;
          selectedObject.objectB.scale.set(0.5, 0.5, 0.5);
          this.$refs.modelViewer._data.object = null;
          this.$refs.modelViewer._props.src = null;
        }

        let box = new Box3().setFromObject(this.$refs.modelViewer._data.wrapper)
        let sphere = box.getBoundingSphere()
        let centerPoint = sphere.center

        this.$refs.modelViewer._data.wrapper.position.x = centerPoint.x;
        this.$refs.modelViewer._data.wrapper.position.y = centerPoint.y;
        this.$refs.modelViewer._data.wrapper.position.z = centerPoint.z;
      },
      selectColor: function(color) {
        var selectedObject = this.objects[this.selectedMedication];
        selectedObject.objectA.material.color.setStyle(color);
        console.log(this.$refs.modelViewer.object);
        console.log(this.$refs);
      }
    },
    mounted() {
    // Include mailchimp scripts
    let validateScript = document.createElement("script");
    validateScript.setAttribute(
      "src",
      "//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"
      );
    document.head.appendChild(validateScript);
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}
h3{
  font-size: 24pt;
  opacity: 0.5;
}
h1 {
  color: #ff9000;
  font-size: 32pt;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.row {
  margin: 0;
}

.head{
  text-align: center;
  background-color: white;
  height: 600px;
  overflow: hidden;
  position: relative;
}

.welcome{
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  margin-top: -150px;
}

.welcome h1{
  margin: 0px;
}

.tracker{
  display: inline-block;
  width: 320px;
  height: 320px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat; 
}

@keyframes crossFade {
  0% {
    opacity:1;
  }
  17% {
    opacity:1;
  }
  25% {
    opacity:0;
  }
  92% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
}

.navigation {
  text-align: left;
  padding-top: 32px;
}
.head {
  min-height: 400px;
}

.logo{
  margin-top: 32px;
}
.logotype {
  font-size: 24pt;
  padding: 8px;
  font-weight: bold;
  color: #007eff;
}

.menu-button {
  margin-left: 8px;
  font-weight: bold;
}

.inhalers {
  max-height: 320px;
}

.sections section {
  margin-bottom: 16px;
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.08);
  padding: 0 16px;
}

.call {
  background-color: #007eff;
  margin-top: -32px;
  margin-bottom: 16px;
  color: white;
  padding: 16px;
  font-weight: bold;
  position: relative;
  z-index: 100;
}

.content {
  text-align: justify;
  background-color: white;
}

.render {
  max-height: 320px;
}

.editor {
  background-color: white;
  text-align: left;
}
.color {
  width: 32px;
  height: 32px;
  display: inline-block;
}
.offer {
  color: #42b983;
  font-weight: bold;
  font-size: 16pt;
}

.features {
  background-color: white;
  text-align: justify;
}
.features .fa-2x {
  color: #ff9000;
}
.feature h4 {
  font-size: 16pt;
  color: #ff9000;
  margin: 0;
}

.onboard {
  text-align: left;
  background-color: #007eff;
  color: white;
}

.onboard a {
  color: inherit;
}

#mc_embed_signup {
  color: black;
  background: #fff;
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
}

.btn {
  position: relative;

  display: block;
  margin: 30px auto;
  padding: 0;

  overflow: hidden;

  border-width: 0;
  outline: none;
  border-radius: 2px;

  background-color: #2ecc71;
  color: #ecf0f1;
  font-weight: bold;
  cursor: pointer;

  transition: background-color 0.3s;
}

.btn:hover,
.btn:focus {
  background-color: #27ae60;
}

.btn > * {
  position: relative;
}

.btn span {
  display: block;
  padding: 12px 24px;
}

.btn:before {
  content: "";

  position: absolute;
  top: 50%;
  left: 50%;

  display: block;
  width: 0;
  padding-top: 0;

  border-radius: 100%;

  background-color: rgba(236, 240, 241, 0.3);

  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.btn:active:before {
  width: 120%;
  padding-top: 120%;

  transition: width 0.2s ease-out, padding-top 0.2s ease-out;
}

.btn.orange {
  background-color: #e67e22;
}
</style>




// WEBPACK FOOTER //
// src/components/Home.vue